// internationalization
import { useTranslation } from 'react-i18next';

// tanstack
import { createFileRoute, useNavigate } from '@tanstack/react-router';

// shared components
import PageContainer from '@/components/layout/PageContainer';
import PageHeader from '@/components/layout/PageHeader';

// components
import CreateAccountForm from '@/features/account/forms/CreateAccountForm';
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/account/create')({
  component: RouteComponent,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'account-management:createnewaccount.title' },
});

function RouteComponent() {
  const { t } = useTranslation('account-management');

  const navigate = useNavigate();

  const handleCancel = () => {
    navigate({ to: `/` });
  };

  return (
    <PageContainer maxWidth="md">
      <PageHeader
        title={
          t?.('createnewaccount.title', { ns: 'account-management' }) ||
          'Create Account'
        }
        disableArrow
      />
      <CreateAccountForm onCancel={handleCancel} />
    </PageContainer>
  );
}
